export const SESSION_STORAGE_KEY_PREFIX = 'ori-personal-menu-cache';
